import { curCoreClient } from './CoreClient';
import _ from "lodash";
import {User} from "@/types/core";
import {HttpResponse} from "@/types/http";

export class UserService {

  public async getUsers(query: GetUsersQuery): Promise<HttpResponse & GetUsersReply> {

    const allUsersReply = await this.getAllUsers();

    if(allUsersReply.errorMsg)
      return Promise.resolve({errorMsg:allUsersReply.errorMsg, httpCode:allUsersReply.httpCode});

    let allUsers = allUsersReply.userList as UserExtended[];

    // convert the emails to lower case but preserve original email as login is case sensitive
    allUsers = allUsers.map( user => Object.assign(user, {lowerEmail:user.email.toLowerCase()}))
    // we sort by the email
    this.sort(allUsers, 'lowerEmail', query.ascDesc);

    if (query.filter) {

      allUsers = allUsers.filter((user) => {

        if (user.lowerEmail.includes(query.filter.toLowerCase()))
          return true;

        if (user.groupIdList &&
            user.groupIdList.some((groupId) => groupId.toLowerCase().includes(query.filter.toLowerCase())))
          return true;

        return false;
      });
    }

    return Promise.resolve({userPageList:this.paginateUserList(allUsers, query.pageSize)});
  }

  private sort(list: any[], key: string, ascDesc: 'asc'|'desc') {

    // we sort asc first
    list.sort((a, b) => {

      if (a[key] < b[key] || a[key] === undefined) {
        return ascDesc === 'asc' ? -1 : 1;
      } else if (a[key] > b[key] || b[key] === undefined) {
        return ascDesc === 'asc' ? +1 : -1;
      } else
        return 0;
    });

  }


  private async getAllUsers(): Promise<{errorMsg?:string, httpCode?:number, userList?:User[]}>{

    let retList: User[] = [];

    let skip = 0;
    while (true) {

      const resp = await curCoreClient.getUsers({skip, limit: 1000});

      if (resp.errorMsg)
        return Promise.resolve({errorMsg:`Unable to load all users: ${resp.errorMsg}`, httpCode: resp.httpCode});

      if (!resp.userList || resp.userList.length === 0)
        break;

      retList = retList.concat(resp.userList);

      if (resp.userList.length < 1000)
        break;

      // we increment skip
      skip += resp.userList.length;
    }

    return Promise.resolve({userList: retList});
  }

  private paginateUserList(userList: User[], pageSize: number): UserPage[] {

    const chunkedList = _.chunk(userList, pageSize);

    return chunkedList.map((chunkedListItem:any, index:number) => ({
      pageNum: index,
      userList: chunkedListItem,
    }));
  }

}

export interface GetUsersQuery {
  orderBy: 'email';
  ascDesc: 'asc';
  pageSize: number;
  filter: string;
}

export interface GetUsersReply {
  userPageList?: UserPage[];
}

export interface UserPage {
  pageNum: number;
  userList: User[];
}

interface UserExtended extends User{
  lowerEmail: string;
}

export const curUserService = new UserService();